import {DateOnlyInput} from '../components/DateOnlyInput';
import {activeEnquiryStages,type Enquiry} from '../enquiries';
export function EnquiryReopenEditor({enquiry,assignees,busy,onSave}:{enquiry:Enquiry;
 assignees:Array<{id:string;display_name:string}>;busy:boolean;onSave:(body:Record<string,unknown>)=>Promise<boolean>}){
 return <details className="lead-record-disclosure"><summary>Reopen enquiry</summary>
  <section className="panel enquiry-controls"><h2>Reopen enquiry</h2>
   <p>The previous outcome stays in the history. Choose who will progress this opportunity and what happens next.</p>
   <form onSubmit={event=>{event.preventDefault();const f=new FormData(event.currentTarget);void onSave({
    stage:String(f.get('stage')),assignedOwner:String(f.get('assignedOwner')),nextAction:String(f.get('nextAction')),
    followUpDate:String(f.get('followUpDate')),reason:'Enquiry explicitly reopened with an owned next action'});}}>
    <label>Active stage<select disabled={busy} name="stage" required defaultValue="Qualified">
     {activeEnquiryStages.map(stage=><option key={stage}>{stage}</option>)}</select></label>
    <label>Owner for reopened enquiry<select disabled={busy} name="assignedOwner" required defaultValue={assignees.some(a=>a.id===enquiry.assigned_owner_id)?enquiry.assigned_owner_id! : ''}>
     <option value="" disabled>Choose an owner</option>{assignees.map(a=><option key={a.id} value={a.id}>{a.display_name}</option>)}</select></label>
    <label>Next action<textarea disabled={busy} name="nextAction" rows={3} required maxLength={5000}/></label>
    <label>Next action date<DateOnlyInput disabled={busy} name="followUpDate" required/></label>
    <button disabled={busy}>Reopen enquiry</button>
   </form>
  </section>
 </details>;
}
